var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('v-progress-circular',{staticStyle:{"left":"50%","top":"50%","position":"absolute","margin-left":"-32px","margin-top":"-32px"},attrs:{"size":"64","width":"7","value":"60","color":"primary","indeterminate":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }